import {
  createContext,
  useContext,
  PropsWithChildren,
  useState,
  useMemo,
  useRef,
} from 'react';

interface ReelsMediaContext {
  expanded: boolean;
  setExpanded: (arg0: boolean) => void;
  muted: boolean;
  setMuted: (arg0: boolean) => void;
  middleSlide: number | undefined;
  setMiddleSlide: (arg0: number) => void;
}

const ReelsMedia = createContext<ReelsMediaContext | null>(null);

const ReelsMediaProvider: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const [muted, setMuted] = useState<boolean>(true);
  const [middleSlide, setMiddleSlide] = useState<number | undefined>(undefined);

  const value = useMemo(() => {
    return {
      expanded,
      setExpanded,
      muted,
      setMuted,
      middleSlide,
      setMiddleSlide,
    };
  }, [expanded, muted, middleSlide]);

  return <ReelsMedia.Provider value={value}>{children}</ReelsMedia.Provider>;
};

function useReelsMedia(): ReelsMediaContext {
  const context = useContext(ReelsMedia);
  if (!context) {
    throw new Error('useReelsMedia must be used within an ReelsMediaProvider');
  }
  return context;
}

export { ReelsMediaProvider, useReelsMedia };
